export default {"src":"/_next/static/media/generatedByCedille.bf3f20b4.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};